import "./organic.css";
const OrganicWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className="container-fluid  mt-10">{children}</div>;
};

export default OrganicWrapper;
